module.exports = __webpack_public_path__ + "static/media/error404.39784f19.svg";